import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService,GroupService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';



@Component({
  selector: 'app-ordini',
  templateUrl: './ordini.component.html',
  styleUrls: ['./ordini.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService]
})
export class OrdiniComponent implements OnInit {
  @ViewChild('grid') public grid: any;
  ordiniDaApprovare:any=[];
  public initialSortordini: Object;
  public toolbar: string[];


  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];
    this.initialSortordini = {  columns: [{ field: 'NOME_STR', direction: 'Ascending' }]};

    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/ordinidaapprovare',params).subscribe(dataag => {
        this.ordiniDaApprovare=dataag.Result;
        this.grid.localeObj.currentLocale.EmptyRecord = 'Nessun dato da visualizzare ...'; 
      });
    });
  }
  onLoad() { 
    this.grid.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
  }

  goto(){
    this.router.navigateByUrl('/java/arkifatt/login/LogonServletAF?oper=1'.replace('?','QUESTION').replace('=','UGUAL'));
    
  }

  
  apri(data){
 
   
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:3,
        id_ordine:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkifatt/login/LogonServletAF','POST',params);
  
  }
  
}
